// bridgeDispatchSms — fires Bardin Team line SMS for a dispatch question
// or its answer, on top of the in-portal notification triggers that fire
// from the dispatch_questions row.
//
// Fire-and-forget. Errors swallowed via console.warn. Dispatch keeps
// working in-portal even if Twilio is down.
//
// Edge function: /supabase/functions/dispatch-send-sms/index.ts (v1).
// Hardcodes FROM = (470) 937-9490. Reads the canonical question row server
// side so the SMS body, recipients, and asker name are not client-trustable.

import { supabase } from "./supabase";

export async function bridgeDispatchQuestion(question_id: string): Promise<void> {
  try {
    const { error } = await supabase.functions.invoke("dispatch-send-sms", {
      body: { question_id, kind: "question" },
    });
    if (error) console.warn("[bridgeDispatchQuestion] edge function error:", error.message ?? error);
  } catch (err) {
    console.warn("[bridgeDispatchQuestion] unexpected error:", err);
  }
}

export async function bridgeDispatchAnswer(question_id: string): Promise<void> {
  try {
    const { error } = await supabase.functions.invoke("dispatch-send-sms", {
      body: { question_id, kind: "answer" },
    });
    if (error) console.warn("[bridgeDispatchAnswer] edge function error:", error.message ?? error);
  } catch (err) {
    console.warn("[bridgeDispatchAnswer] unexpected error:", err);
  }
}
